
function NextStagesCtrl(TranslationService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    //ctrl.stageList = [];
    
    ctrl.$onInit = function () {
        if (!ctrl.stages) {
            ctrl.stages = [];
        }
    };

    ctrl.applyStages = function () {
        //ctrl.stage.NextStages = ctrl.stageList.join("; ");
        //ctrl.stage.NextStages = ctrl.nextStages;
    };

   
    ctrl.add = function (index) {
        var newField = '';
        //ctrl.stageList.push(newField);
        ctrl.nextStages.push(newField);
    };

    ctrl.deleteStage = function (index) {
        //ctrl.stageList.splice(index, 1);
        ctrl.nextStages.splice(index, 1);
        ctrl.applyStages();
    };

    ctrl.selectOption = function (index, option) {
        console.log('select option ' + index, ctrl.nextStages[index]);
        //ctrl.stageList[index] = option.StageID;
        ctrl.nextStages[index] = option.StageID;
        ctrl.applyStages();
    };

    ctrl.moveItem = function (index, indexfrom) {
        // Implement logic to move the item at the given index
        console.log('moved item ' + index, indexfrom);
        //ctrl.nextStages.splice(index + 1, 1);
        //ctrl.nextStages.splice(index + 1, 1);
    };

    ctrl.onDrop = function (index, stageID, list) {
        console.log('onDrop ' + index, stageID, list);

        //remove movido
        var oldIndex = list.findIndex(function (id) {
            return id == stageID
        });

        if (oldIndex >= 0) {
            list.splice(oldIndex, 1);
        }
        //inser na posicao
        list.splice(index, 0, stageID);
        //console.log('list', list);
        
        return true;
    };

}

NextStagesCtrl.$inject = ['TranslationService'];

seedWebApp.component('nextStages', {
    controller: NextStagesCtrl,
    controllerAs: 'ctrl',
    bindings: {
        stage: '<',       
        stages: '<',
        nextStages: '=',
    },
    templateUrl: '/SPA/settings/stages/nextStages.html' + seedWebApp.buildVersion
});
